import { buildRows } from '~/lib/sizing';
import { SizesValues } from '~/types/sizings';
import reversibleBomberSizing from 'public/assets/images/REVERSIBLE_BOMBER.png';
import hoodieSizing from 'public/assets/images/hoodieSizing.png';
import zipUpSizing from 'public/assets/images/zipUpSizing.png';
import tshirtSizing from 'public/assets/images/tshirtSizing.png';
import longSleeveTshirtSizing from 'public/assets/images/longSleeveTshirtSizing.webp';
import jeansSizing from 'public/assets/images/jeansSizing.png';
import babyTeeImage from 'public/assets/images/babyTee.png';
import jacketSizing from 'public/assets/images/jacketSizing.webp';
import pufferSizing from 'public/assets/images/puffer.png';
import ribbedMensTankTopSizingImage from 'public/assets/images/mensTankSizing.webp';
import mensTankTopSizingImage from 'public/assets/images/MENS_TANK_TOP.png';
import womensTankTopSizing from 'public/assets/images/womensTankSizing.webp';
import sweatpantsSizing from 'public/assets/images/sweatpantsSizing.webp';
import wideSweatpantsSizing from 'public/assets/images/wideSweatpantsSizing.png';
import techJacketSizing from 'public/assets/images/TECH_JACKET.png';
import techPantsSizing from 'public/assets/images/techPantsSizing.webp';
import cargoPantsSizing from 'public/assets/images/CARGO_PANTS.png';
import beanieSizing from 'public/assets/images/beanieSizing.png';
import polarFleeceSizing from 'public/assets/images/polar_fleece.png';
import croppedZipupSizing from 'public/assets/images/cropped_zipup.png';
import knitwearSizing from 'public/assets/images/knitwearSizing.png';
import workwearSizing from 'public/assets/images/workwearSizing.png';
import varsityJacketSizing from 'public/assets/images/varsityJacket.png';
import denimShortsImage from 'public/assets/images/denimShorts.png';
import denimCorsetTopSizing from 'public/assets/images/denimCorsetTop.webp';
import pleatedSkirtSizing from 'public/assets/images/pleatedSkirt.webp';
import ripstopSkirt from 'public/assets/images/ripstopSkirt.webp';
import raglanLongSleeveTShirt from 'public/assets/images/raglanLongSleeveTShirt.webp';
import mensZipKnit from 'public/assets/images/mensZipKnit.webp';
import womensZipKnit from 'public/assets/images/womensZipKnit.webp';
import sweatSorts from 'public/assets/images/sweatSorts.webp';
import bikini from 'public/assets/images/bikini.webp';
import buttonUpShirt from 'public/assets/images/BUTTON_UP_SHIRT.png';
import slinkySkirt from 'public/assets/images/slinky_skirt.webp';
import straightLegSweatpants from 'public/assets/images/straight_leg_sweatpants.png';
import halterTop from 'public/assets/images/halter_top.webp';
import footballMeshShorts from 'public/assets/images/american_football_shorts.webp';
import footballJersey from 'public/assets/images/FOOTBALL_JERSEY.png';
import performanceTShirt from 'public/assets/images/performance_t_shirt.webp';
import trackPants from 'public/assets/images/track_pants.png';
import trackTop from 'public/assets/images/track_top.png';
import sweatSkirt from 'public/assets/images/sweatSkirt.webp';
import croppedBoxyTshirt from 'public/assets/images/boxy_tshirt.webp';
import loungeCorset from 'public/assets/images/corset.webp';
import swimmingShorts from 'public/assets/images/swimming_shorts.webp';
import womensShorts from 'public/assets/images/women_shorts.webp';
import wideLegDenim from 'public/assets/images/wide-leg-jeans_1.webp';
import waffleLongSleeve from 'public/assets/images/waffle-long-sleeve.webp';
import racerJacket from 'public/assets/images/racer-jacket.webp';
import womensFootballJersey from 'public/assets/images/womens-football-jersey_1.webp';
import cuffedSweatpants from 'public/assets/images/cuffed_sweatpants.png';
import layeredTShirt from 'public/assets/images/layered_t_shirt.png';
import lightweightTank from 'public/assets/images/lightweight_tank.png';
import oneShoulderTop from 'public/assets/images/one_shoulder_top.png';
import velourJacket from 'public/assets/images/velour_jacket.png';
import velourTrackPants from 'public/assets/images/velour_track_pants.png';
import newPolarFleece from 'public/assets/images/FLEECE.png';
import foldoverBeanie from 'public/assets/images/foldover_beanie.png';
import starCamoBeanie from 'public/assets/images/star_camo_beanie.png';
import fauxFurZipUpHoodieImg from 'public/assets/images/FAUX_FUR_ZIP_UP_HOODIE.png';
import boxers from 'public/assets/images/boxers.png';
import topLeagueTrackJacket from 'public/assets/images/top_league_track_jacket.png';
import topLeagueTrackPants from 'public/assets/images/top_league_track_pants.png';
import velourPants from 'public/assets/images/velour_pants.png';
import workwearJacket from 'public/assets/images/workwearJacket.png';
import racerKnit from 'public/assets/images/racerKnit.png';
import pixelStarBeanie from 'public/assets/images/pixelStarBeanie.png';
import camoCargosImg from 'public/assets/images/CARGO_PANTS.png';
import ShortsImage from 'public/assets/images/SHORTS.png';
import LightWeightTankImage from 'public/assets/images/LIGHT_WEIGHT_TANK.png';
import jerseyImage from 'public/assets/images/jersey.png';
import meshShortsImage from 'public/assets/images/mesh_shorts.png';
import cottonTrackTopImage from 'public/assets/images/cotton_track_top.png';
import longSleeveImage from 'public/assets/images/long_sleeve_star_camo_jersey_size_image.png';
import americanFootballJerseyImage from 'public/assets/images/american_football_jersey_size_image.png';
import starGirlTeeImage from 'public/assets/images/star_girl_tee_size_image.png';
import twoInTwoCargoPantsShortsImage from 'public/assets/images/2_in_2_cargo_pants_shorts_size_image.png';
import womensTankTopSizesImage from 'public/assets/images/WOMENS_TANK_TOP.png';
import FurZipUpHoodieImage from 'public/assets/images/FUR_ZIP_UP.png';
import stargirlZipUpHoodieSizing from 'public/assets/images/stargirl-zip-up-hoodie-sizing.png';
import stargirlCorsetZipUpHoodieSizing from 'public/assets/images/stargirl-corset-zip-up-hoodie-sizing.png';
import basicsZipUpHoodieSizing from 'public/assets/images/basics-zip-up-hoodie-sizing.png';
import planetSweaterSizing from 'public/assets/images/PLANET_SWEATER.png';
import zipUpSweaterSizing from 'public/assets/images/ZIP_UP_SWEATER.png';
import flannelShirtSizing from 'public/assets/images/FLANNEL_SHIRT.png';
import crewneckSizingImage from 'public/assets/images/CREW_NECK.png';

export type TableSizes = {
  sizeChartType: string;
  sizes: SizesValues;
};

export const reversibleBomberSizes: TableSizes = {
  sizeChartType: 'ReversibleBomberSizes',
  sizes: {
    lengthFromHSP: ['-', 62, 64, 66, 68, 70, '-', '-'],
    underarmChest: ['-', 64, 66, 68, 70, 72, '-', '-'],
    hem: ['-', 41.5, 43.5, 45.5, 47.5, 49.5, '-', '-'],
    sleeveLength: ['-', 56.5, 58, 59.5, 61, 62.5, '-', '-'],
  },
};

export const hoodieSizes: TableSizes = {
  sizeChartType: 'TopSizes',
  sizes: {
    lengthFromHSP: [61, 63, 65, 67, 69, 71, 73, 75],
    chest: [60, 62, 64, 66, 68, 70, 72, 74],
    hem: [37, 39, 41, 43, 45, 47, 49, 51],
    sleeveLength: [56, 57.5, 59, 60.5, 62, 63.5, 65, 66.5],
  },
};

export const crewneckSizes: TableSizes = {
  sizeChartType: 'TopSizes',
  sizes: {
    lengthFromHSP: ['-', 63, 65, 67, 69, 71, 73, '-'],
    underarmChest: ['-', 64, 66, 68, 70, 72, 74, '-'],
    hem: ['-', 39, 41, 43, 45, 47, 49, '-'],
    sleeveLength: ['-', 57.5, 59, 60.5, 62, 63.5, 65, '-'],
  },
};

export const zipUpSizes: TableSizes = {
  sizeChartType: 'TopSizes',
  sizes: {
    lengthFromHSP: [59, 61, 63, 65, 67, 69, 71, 73],
    underarmChest: [62, 64, 66, 68, 70, 72, 74, 76],
    hem: [46, 48, 50, 52, 54, 56, 58, 60],
    sleeveLength: [51, 52.5, 54, 55.5, 57, 58.5, 60, 61.5],
  },
};

export const basicsZipUpHoodieSizes: TableSizes = {
  sizeChartType: 'TopSizes',
  sizes: {
    lengthFromHSP: [59, 61, 63, 65, 67, 69, 71, 73],
    underarmChest: [62, 64, 66, 68, 70, 72, 74, 76],
    hem: [46, 48, 50, 52, 54, 56, 58, 60],
    sleeveLength: [51, 52.5, 54, 55.5, 57, 58.5, 60, 61.5],
  },
};

export const stargirlZipUpHoodieSizes: TableSizes = {
  sizeChartType: 'TopSizes',
  sizes: {
    lengthFromHSP: [50.5, 52.5, 54.5, 56.5, 58.5, 60.5, 62.5, 64.5],
    underarmChest: [58, 60, 62, 64, 66, 68, 70, 72],
    hem: [36, 38, 40, 42, 44, 46, 48, 50],
    sleeveLength: [56, 57.5, 59, 60.5, 62, 63.5, 65, 66.5],
  },
};

export const stargirlCorsetZipUpHoodieSizes: TableSizes = {
  sizeChartType: 'TopSizes',
  sizes: {
    lengthFromHSP: ['-', 53, 54.5, 56, 57.5, 59, 60.5, '-'],
    underarmChest: ['-', 47, 49, 51, 53, 55, 57, '-'],
    hem: ['-', 28.5, 30.5, 32.5, 34.5, 36.5, 38.5, '-'],
    sleeveLength: ['-', 73.5, 75, 76.5, 78, 79.5, 81, '-'],
  },
};

export const polarFleeceSizes: TableSizes = {
  sizeChartType: 'PolarFleeceSizes',
  sizes: {
    frontLength: ['-', 59.6, 61.3, 63, 64.7, 66.4, 68.1, '-'],
    chest: ['-', 67, 69, 71, 73, 75, 77, '-'],
    hem: ['-', 49.5, 51.5, 53.5, 55.5, 57.5, 59.5, '-'],
    sleeveLength: ['-', 76, 79, 82, 85, 88, 91, '-'],
  },
};

export const croppedZipupSizes: TableSizes = {
  sizeChartType: 'PolarFleeceSizes',
  sizes: {
    frontLength: ['-', 39.5, 40, 42, 44, '-', '-', '-'],
    chest: ['-', 52, 54, 56, 58, '-', '-', '-'],
    hem: ['-', 34, 36, 38, 40, '-', '-', '-'],
    sleeveLength: ['-', 57, 58.5, 60, 61.5, '-', '-', '-'],
  },
};

export const tshirtSizes: TableSizes = {
  sizeChartType: 'TopSizes',
  sizes: {
    lengthFromHSP: [62.5, 64.5, 66.5, 68.5, 70.5, 72.5, 74.5, 76.5],
    underarmChest: [55, 57, 59, 61, 63, 65, 67, 69],
    hem: [53.5, 55.5, 57.5, 59.5, 61.5, 63.5, 65.5, 67.5],
    sleeveLength: [24, 24.5, 25, 25.5, 26, 26.5, 27, 27.5],
  },
};

export const babyTeeSizes: TableSizes = {
  sizeChartType: 'BabyTeeSizes',
  sizes: {
    lengthHSP: ['-', 45, 47, 49, 51, 53, 55, '-'],
    chest: ['-', 36, 38, 40, 42, 44, 46, '-'],
    hem: ['-', 36, 38, 40, 42, 44, 46, '-'],
  },
};

export const ribbedMensTankTopSizes: TableSizes = {
  sizeChartType: 'RibbedTankTopSizes',
  sizes: {
    frontLength: ['-', 51.2, 53.2, 55.2, 57.2, 59.2, 61.2, '-'],
    hem: ['-', 42.5, 44.5, 46.5, 48.5, 50.5, 52.5, '-'],
  },
};
export const mensTankTopSizes: TableSizes = {
  sizeChartType: 'MensTankTopSizes',
  sizes: {
    frontLength: ['-', 47.5, 49.5, 51.5, 53.5, 55.5, 57.5, '-'],
    underarmChest: ['-', 38, 40, 42, 44, 46, 48, '-'],
    hem: ['-', 38, 40, 42, 44, 46, 48, '-'],
  },
};

export const ribbedWomensTankTopSizes: TableSizes = {
  sizeChartType: 'WomanTankTopSizesWoman',
  sizes: {
    frontLength: ['-', 23, 25, 27, 29, 31, 33, '-'],
    hem: ['-', 28.5, 30.5, 32.5, 34.5, 36.5, 38.5, '-'],
  },
};
export const womensTankTopSizes: TableSizes = {
  sizeChartType: 'RibbedTankTopSizesWoman',
  sizes: {
    lengthFromHSP: ['-', 41.5, 43.5, 45.5, 47.5, 49.5, 51.5, '-'],
    underarmChest: ['-', 30.5, 32.5, 34.5, 36.5, 38.5, 40.5, '-'],
    hem: ['-', 30.5, 32.5, 34.5, 36.5, 38.5, 40.5, '-'],
  },
};

export const longSleeveTshirtSizes: TableSizes = {
  sizeChartType: 'TopSizes',
  sizes: {
    lengthHSP: ['-', 63.5, 65.5, 67.5, 69.5, 71.5, 73.5, '-'],
    underarmChest: ['-', 62, 64, 66, 68, 70, 72, '-'],
    hem: ['-', 62, 64, 66, 68, 70, 72, '-'],
    sleeveLength: ['-', 58, 59, 60, 61, 62, 63, '-'],
  },
};

export const wideSweatpantsSizes: TableSizes = {
  sizeChartType: 'PantsSizes',
  sizes: {
    waist: [28, 30, 32, 34, 36, 38, 40, 42],
    hem: [29.2, 29.8, 30.6, 31.4, 32.3, 33, 33.8, 34.6],
    lengthCF: [99, 101, 103, 105, 107, 109, 111, 113],
  },
};

export const sweatpantsSizes: TableSizes = {
  sizeChartType: 'SweatpantsSizes',
  sizes: {
    waist: [32, 34, 36, 38, 40, 42, 44, 46],
    hip: [40.5, 42.5, 44.5, 46.5, 48.5, 50.5, 52.5, 54.5],
    thigh: [32.5, 33.5, 34.5, 35.5, 36.5, 37.5, 38.5, 39.5],
    inseam: [66, 67, 68, 69, 70, 71, 72, 73],
  },
};

export const cargoSizes: TableSizes = {
  sizeChartType: 'CargoSizes',
  sizes: {
    waist: ['-', 78, 82, 86, 90, 94, 98, '-'],
    hem: ['-', 29.5, 30, 30.5, 31, 31.5, 32, '-'],
    insideLeg: ['-', 75, 75, 75, 78, 78, 78, '-'],
  },
};

export const techPantsSizes: TableSizes = {
  sizeChartType: 'PantsSizes',
  sizes: {
    waist: [29, 30, 33, 35, 37, 39, 41, 43],
    thigh: [31.5, 32.5, 33.5, 34.5, 35.5, 36.5, 37.5, 38.5],
    inseam: [73, 74, 75, 76, 77, 78, 79, 80],
  },
};

export const jacketSizes: TableSizes = {
  sizeChartType: 'TopSizes',
  sizes: {
    fullLength: ['-', '-', 56, 58, 60, 62, 64, 66],
    chest: ['-', '-', 58, 60, 62, 64, 66, 68],
    centreLength: ['-', '-', 51, 53, 55, 56.5, 58.5, 60],
    sleeveLength: ['-', '-', 63, 64.5, 66, 67.5, 69, 70.5],
  },
};

export const pufferSizes: TableSizes = {
  sizeChartType: 'PufferSizes',
  sizes: {
    lengthFromHSP: ['-', 65, 67, 69, 71, 73, 75, '-'],
    underarmChest: ['-', 61, 63, 65, 67, 69, 71, '-'],
    hem: ['-', 60, 62, 64, 66, 68, 70, '-'],
  },
};

export const techJacketSizes: TableSizes = {
  sizeChartType: 'TechJacketSizes',
  sizes: {
    lengthFromHSP: ['-', 64, 66, 68, 70, 72, 74, '-'],
    chest: ['-', 65, 67, 69, 71, 73, 75, '-'],
    hem: ['-', 61, 63, 65, 67, 69, 71, '-'],
    sleeveLength: ['-', 55, 56.5, 58, 59.5, 61, 62.5, '-'],
  },
};

export const varsityJacketSizes: TableSizes = {
  sizeChartType: 'VarsityJacketSizes',
  sizes: {
    lengthFromHSP: ['-', 60.5, 62.5, 64.5, 66.5, 68.5, 70.5, '-'],
    underarmChest: ['-', 64, 66, 68, 70, 72, 74, '-'],
    hem: ['-', 51, 53, 55, 57, 59, 61, '-'],
    sleeveLength: ['-', 54, 55, 56, 57, 58, 59, '-'],
  },
};

export const beanieSizes: TableSizes = {
  sizeChartType: 'BeanieSizes',
  sizes: {
    headFlat: [22],
    height: [22],
    turnOver: [8],
  },
};

export const foldoverBeanieSizes: TableSizes = {
  sizeChartType: 'FoldoverBeanieSizes',
  sizes: {
    width: [23],
    height: [20],
  },
};

export const starCamoBeanieSizes: TableSizes = {
  sizeChartType: 'StarCamoBeanieSizes',
  sizes: {
    width: [26],
    height: [20],
  },
};

export const workwearSizes: TableSizes = {
  sizeChartType: 'PolarFleeceSizes',
  sizes: {
    fullLength: ['-', 68, 70, 72, 74, 76, 78, '-'],
    chest: ['-', 64.5, 66.5, 68.5, 70.5, 72.5, 74.5, '-'],
    hem: ['-', 40, 42, 44, 46, 48, 50, '-'],
    sleeveLength: ['-', 67, 68.5, 70, 71.5, 73, 74.5, '-'],
  },
};

export const workwearJacketSizes: TableSizes = {
  sizeChartType: 'WorkwearJacketSizes',
  sizes: {
    lengthFromHSP: ['-', 65, 67, 69, 71, 73, 75, '-'],
    underarmChest: ['-', 64.5, 66.5, 68.5, 70.5, 72.5, 74.5, '-'],
    hem: ['-', 40, 42, 44, 46, 48, 50, '-'],
    sleeveLength: ['-', 62, 63.5, 65, 66.5, 68, 69.5, '-'],
  },
};

export const knitJacketSizes: TableSizes = {
  sizeChartType: 'PolarFleeceSizes',
  sizes: {
    frontLength: ['-', '-', 62, 64, 66, 68, 70, '-'],
    chest: ['-', '-', 61, 63, 65, 67, 69, '-'],
    hem: ['-', '-', 54, 56, 58, 60, 62, '-'],
    sleeveLength: ['-', '-', 67, 68, 69, 70, 71, '-'],
  },
};

export const denimJeansSizes: TableSizes = {
  sizeChartType: 'DenimPantsSizes',
  sizes: {
    fullWaist: ['-', 82, 86, 90, 94, 98, 102, '-'],
    hip: ['-', 56, 58, 60, 62, 64, 66, '-'],
    insideLeg: ['-', 71, 71, 74, 76, 76, 76, '-'],
    hem: ['-', 28.5, 29, 29.5, 30, 30.5, 31, '-'],
  },
};

export const denimShortsSizes: TableSizes = {
  sizeChartType: 'DenimShortsSizes',
  sizes: {
    waist: ['-', 80, 84, 88, 92, 96, 100, '-'],
    hem: ['-', 35.5, 36.5, 37.5, 38.5, 39.5, 40.5, '-'],
    lengthIncWaist: ['-', 61, 61.5, 64, 64.5, 67, 67.5, '-'],
  },
};

export const sweatShortsSizing: TableSizes = {
  sizeChartType: 'SweatShortSizes',
  sizes: {
    waist: [34, 36, 38, 40, 42, 44, 46, 48],
    length: [46.5, 47.5, 48.5, 49.5, 50.5, 51.5, 52.5, 53.5],
    hem: [31, 32, 33, 34, 35, 36, 37, 38],
  },
};
export const denimCorsetSizing: TableSizes = {
  sizeChartType: 'CorsetSizes',
  sizes: {
    waist: ['-', 34, 36, 38, 40, 42, 44, '-'],
    chest: ['-', 41, 43, 45, 47, 49, 51, '-'],
    frontLength: ['-', 23.4, 24.2, 25, 25.8, 26.6, 27.4, '-'],
  },
};

export const denimSkirtSizing: TableSizes = {
  sizeChartType: 'SkirtSizes',
  sizes: {
    waist: ['-', 33, 35, 37, 39, 41, 43, '-'],
    hip: ['-', 46, 48, 50, 52, 54, 56, '-'],
    length: ['-', 28.7, 29.3, 29.9, 30.5, 31.3, 31.7, '-'],
  },
};

export const ripstopSkirtSizes: TableSizes = {
  sizeChartType: 'RipstopSkirtSizes',
  sizes: {
    waist: ['-', 34, 36, 38, 40, 42, '-', '-'],
    hip: ['-', 48.5, 50.5, 52.5, 54.5, 56.5, '-', '-'],
    hem: ['-', 54, 56, 58, 60, 62, '-', '-'],
    sideSeam: ['-', 34.5, 35.5, 36.5, 37.5, 38.5, '-', '-'],
  },
};

export const thermalLongSleeveSizes: TableSizes = {
  sizeChartType: 'ThermalLongSleeve',
  sizes: {
    fullLength: ['-', 67, 69, 71, 73, 75, 77, '-'],
    chest: ['-', 58, 60, 62, 64, 66, 68, '-'],
    hem: ['-', 55, 57, 59, 61, 63, 65, '-'],
    sleeveLengthFromNeck: ['-', 74.5, 77, 79.5, 82, 84.5, 87, '-'],
  },
};

export const mensWashedRibbedZipUpSizes: TableSizes = {
  sizeChartType: 'PolarFleeceSizes',
  sizes: {
    frontLength: ['-', 62, 63.5, 65, 66.5, 68, 69.5, '-'],
    chest: ['-', 49, 51, 53, 55, 57, 59, '-'],
    hem: ['-', 49, 51, 53, 55, 57, 59, '-'],
    sleeveLength: ['-', 73, 74, 75, 76, 77, 78, '-'],
  },
};

export const womensWashedRibbedZipUpSizes: TableSizes = {
  sizeChartType: 'PolarFleeceSizes',
  sizes: {
    frontLength: ['-', 47, 48.5, 50, 51.5, 53, 54.5, '-'],
    chest: ['-', 35, 37, 39, 41, 43, 45, '-'],
    hem: ['-', 33, 35, 37, 39, 41, 43, '-'],
    sleeveLength: ['-', 58, 59, 60, 61, 62, 63, '-'],
  },
};

export const bikiniSizes: TableSizes = {
  sizeChartType: 'BikiniSizes',
  sizes: {
    topCupHeight: ['-', 14, 15, 16, 18, 20.5, '-', '-'],
    bottomFrontWidth: ['-', 14.5, 15.5, 17.5, 18.5, 19.5, '-', '-'],
    bottomFrontHeight: ['-', 22, 24, 26, 28, 30, '-', '-'],
    gussetWidth: ['-', 5, 5, 5, 5, 5, '-', '-'],
  },
};

export const footballMeshShortsSizes: TableSizes = {
  sizeChartType: 'FootballMeshShortsSizes',
  sizes: {
    waist: [34, 36, 38, 40, 42, 44, 46, 48],
    hem: [31, 32, 33, 34, 35, 36, 37, 38],
    length: [49.5, 50.5, 51.5, 52.5, 53.5, 54.5, 55.5, 56.5],
  },
};

export const halterTopSizes: TableSizes = {
  sizeChartType: 'HalterTopSizes',
  sizes: {
    lengthCF: ['-', 21.5, 22, 22.5, 23, 23.5, '-', '-'],
    chest: ['-', 33, 35, 37, 39, 41, '-', '-'],
    hem: ['-', 33, 35, 37, 39, 41, '-', '-'],
  },
};

export const straightLegSweatpantsSizes: TableSizes = {
  sizeChartType: 'StraightLegSweatpantsSizes',
  sizes: {
    waist: ['-', 31, 33, 35, 37, 39, 41, '-'],
    hem: ['-', 25.4, 26.4, 27.4, 28.2, 29, 29.8, '-'],
    length: ['-', 101, 103, 105, 107, 109, 111, '-'],
  },
};

export const slinkySkirtSizes: TableSizes = {
  sizeChartType: 'SlinkySkirtSizes',
  sizes: {
    length: ['-', 28, 28.5, 29, 29.5, 30, '-', '-'],
    waist: ['-', 32.5, 34.5, 36.5, 38.5, 40.5, '-', '-'],
    hip: ['-', 44.5, 46.5, 48.5, 50.5, 52.5, '-', '-'],
  },
};

export const buttonUpShirtSizes: TableSizes = {
  sizeChartType: 'ButtonUpShirtSizes',
  sizes: {
    frontLengthHSP: ['-', 64, 66, 68, 70, 72, 74, '-'],
    underarmChest: ['-', 53, 55, 57, 59, 61, 63, '-'],
    hem: ['-', 53, 55, 57, 59, 61, 65.5, '-'],
    sleeveLength: ['-', 27, 27.5, 28, 28.5, 29, 29.5, '-'],
  },
};

export const cuffedSweatpantsSizes: TableSizes = {
  sizeChartType: 'CuffedSweatpantsSizes',
  sizes: {
    waist: [31, 33, 35, 37, 39, 41, 42, 43],
    hem: [11.8, 12.6, 13.4, 14.2, 15, 15.8, 16.6, 17.4],
    length: [105, 107, 109, 111, 113, 115, 117, 119],
  },
};

export const newHoodieShapeSizes: TableSizes = {
  sizeChartType: 'NewHoodieShapeSizes',
  sizes: {
    lengthHSP: [61, 63, 65, 67, 69, 71, 73, 75],
    chest: [60, 62, 64, 66, 68, 70, 72, 74],
    hem: [37, 39, 41, 43, 45, 47, 49, 51],
    sleeveLength: [56, 57.5, 59, 60.5, 62, 63.5, 65, 66.5],
  },
};

export const lightweightTankSizes: TableSizes = {
  sizeChartType: 'LightweightTankSizes',
  sizes: {
    frontLength: ['-', 47.5, 49.5, 51.5, 53.5, 55.5, 57.5, '-'],
    chest: ['-', 38, 40, 42, 44, 46, 48, '-'],
    hem: ['-', 38, 40, 42, 44, 46, 48, '-'],
  },
};

export const longSleeveSizes: TableSizes = {
  sizeChartType: 'LongSleeveSizes',
  sizes: {
    lengthHSP: ['-', 63.5, 65.5, 67.5, 69.5, 71.5, 73.5],
    underarmChest: ['-', 62, 64, 66, 68, 70, 72],
    hem: ['-', 62, 64, 66, 68, 70, 72],
    sleeveLength: ['-', 58, 59, 60, 61, 62, 63],
  },
};

export const womensOneShoulderTopSizes: TableSizes = {
  sizeChartType: 'WomensOneShoulderTopSizes',
  sizes: {
    frontLength: ['-', 45, 47, 49, 51, 53, 55, '-'],
    chest: ['-', 33.5, 35.5, 37.5, 39.5, 41.5, 43.5, '-'],
    hem: ['-', 30, 32, 34, 36, 38, 40, '-'],
    shoulder: ['-', 5.5, 5.5, 5.5, 5.5, 5.5, 5.5, '-'],
  },
};
export const newPolarFleeceSizes: TableSizes = {
  sizeChartType: 'NewPolarFleeceSizes',
  sizes: {
    lengthFromHSP: ['-', 61, 63, 65, 67, 69, 71, '-'],
    underarmChest: ['-', 63, 65, 67, 69, 71, 73, '-'],
    hem: ['-', 46, 48, 50, 52, 54, 56, '-'],
    sleeveLengthFromNeckline: ['-', 52, 55, 57, 59, 61, 63, '-'],
  },
};

export const velourSweatpantsSizes: TableSizes = {
  sizeChartType: 'VelourSweatpantsSizes',
  sizes: {
    frontLengthIncWaist: [95, 97, 99, 101, 103, 105, 107, 109],
    hip: [52, 54, 56, 58, 60, 62, 64, 66],
    hem: [29.2, 29.8, 30.6, 31.4, 32.2, 33, 33.8, 34.6],
    waist: [28, 30, 32, 34, 36, 38, 40, 42],
  },
};
export const velourTrackPantsSizes: TableSizes = {
  sizeChartType: 'VelourTrackPantsSizes',
  sizes: {
    lengthIncWaist: [95, 97, 99, 101, 103, 105, 107, 109],
    waist: [28, 30, 32, 34, 36, 38, 40, 42],
    hem: [29.2, 29.8, 30.6, 31.4, 32.2, 33, 33.8, 34.6],
  },
};

export const meshLayeredTShirtSizes: TableSizes = {
  sizeChartType: 'MeshLayeredTShirtSizes',
  sizes: {
    lengthFromHSP: [62.5, 64.5, 66.5, 68.5, 70.5, 72.5, 74.5, 76.5],
    underarmChest: [55, 57, 59, 61, 63, 65, 67, 69],
    sleeveLength: [24, 24.5, 25, 25.5, 26, 26.5, 27, 27.5],
  },
};

export const velourTrackJacketSizes: TableSizes = {
  sizeChartType: 'VelourTrackJacketSizes',
  sizes: {
    lengthFromHSP: ['-', 47, 49, 51, 53, 55, 57, '-'],
    underarmChest: ['-', 48.5, 50.5, 52.5, 54.5, 56.5, 58.5, '-'],
    hem: ['-', 30.5, 32.5, 34.5, 36.5, 38.5, 40.5, '-'],
    sleeveLength: ['-', 74.5, 76, 77.5, 79, 80.5, 82, '-'],
  },
};

export const footballJerseySizes: TableSizes = {
  sizeChartType: 'FootballJerseySizes',
  sizes: {
    lengthHSP: ['-', 67, 69, 71, 73, 75, 77, '-'],
    chest: ['-', 56, 58, 60, 62, 64, 66, '-'],
    hem: ['-', 56, 58, 60, 62, 64, 66, '-'],
    sleeveLength: ['-', 41.5, 42, 42.5, 43, 43.5, 44, '-'],
  },
};

export const americanFootballJerseySizes: TableSizes = {
  sizeChartType: 'AmericanFootballJerseySizes',
  sizes: {
    lengthHSP: ['-', 66, 68, 70, 72, 74, 76, ' -'],
    underarmChest: ['-', 58, 60, 62, 64, 66, 68, '-'],
    hem: ['-', 59, 61, 63, 65, 67, 69, '-'],
  },
};

export const trackTopSizes: TableSizes = {
  sizeChartType: 'TrackTopSizes',
  sizes: {
    lengthHSP: ['-', 66.5, 68.5, 70.5, 72.5, 74.5, 76.5, '-'],
    chest: ['-', 57, 59, 61, 63, 65, 67, '-'],
    hem: ['-', 43, 45, 47, 49, 51, 53, '-'],
    sleeveLength: ['-', 79, 80.5, 82, 83.5, 85, 86.5, '-'],
  },
};
export const performanceTShirtSizes: TableSizes = {
  sizeChartType: 'PerformanceTShirtSizes',
  sizes: {
    lengthHSP: ['-', 66, 68, 70, 72, 74, 76, '-'],
    chest: ['-', 56, 58, 60, 62, 64, 66, '-'],
    hem: ['-', 56, 58, 60, 62, 64, 66, '-'],
    sleeveLength: ['-', 42.5, 43, 43.5, 44, 44.5, 45, '-'],
  },
};

export const trackPantsSizes: TableSizes = {
  sizeChartType: 'TrackPantsSizes',
  sizes: {
    lengthIncWaist: ['-', 101, 103, 105, 107, 109, 111, '-'],
    waist: ['-', 32, 34, 36, 38, 40, 42, '-'],
    hip: ['-', 54, 56, 58, 60, 62, 64, '-'],
    hem: ['-', 29.8, 30.6, 32.4, 32.2, 33, 33.8, '-'],
  },
};

export const sweatSkirtSizes: TableSizes = {
  sizeChartType: 'SweatSkirtSizes',
  sizes: {
    waist: ['-', 30, 32, 34, 36, 38, 40, '-'],
    hem: ['-', 53.5, 55.5, 57.5, 59.5, 61.5, 63.5, '-'],
    length: ['-', 32.5, 33.5, 34.5, 35.5, 36.5, 37.5, '-'],
  },
};

export const croppedBoxyTshirtSizes: TableSizes = {
  sizeChartType: 'CroppedBoxyTshirtSizes',
  sizes: {
    lengthFromHSP: ['-', 62, 64, 66, 68, 70, 72, '-'],
    chest: ['-', 59, 61, 63, 65, 67, 69, '-'],
    hemWidth: ['-', 59, 61, 63, 65, 67, 69, '-'],
  },
};

export const loungeCorsetSizes: TableSizes = {
  sizeChartType: 'LoungeCorsetSizes',
  sizes: {
    centreLength: ['-', 29, 30, 31, 32, 33, 34, '-'],
    chest: ['-', 34.5, 36.5, 38.5, 40.5, 42.5, 44.5, '-'],
    hemWidth: ['-', 33.5, 35.5, 37.5, 39.5, 41.5, 43.5, '-'],
  },
};

export const womensShortsSizes: TableSizes = {
  sizeChartType: 'WomensShortsSizes',
  sizes: {
    waist: [32, 34, 36, 38, 40, 42, '-', '-'],
    hem: [28.5, 29.5, 30.5, 31.5, 32.5, 33.5, '-', '-'],
    lengthWidthWaistband: [29, 30, 31, 32, 33, 34, '-', '-'],
  },
};

export const swimmingShortsSizes: TableSizes = {
  sizeChartType: 'SwimmingShortsSizes',
  sizes: {
    waist: [34, 36, 38, 40, 42, 44, 46, 48],
    hem: [31, 32, 33, 34, 35, 36, 37, 38],
    length: [46.5, 47.5, 48.5, 49.5, 50.5, 51.5, 52.5, 53.5],
  },
};

export const wideLegDenimSizes: TableSizes = {
  sizeChartType: 'WideLegDenimSizes',
  sizes: {
    waist: ['-', 82, 86, 90, 94, 98, 102, '-'],
    hip: ['-', 56, 58, 60, 62, 64, 66, '-'],
    insideLeg: ['-', 71, 71, 74, 76, 76, 76, '-'],
    hem: ['-', 28.5, 29, 29.5, 30, 30.5, 31, '-'],
  },
};

export const racerJacketSizes: TableSizes = {
  sizeChartType: 'RacerJacketSizes',
  sizes: {
    fullLength: ['-', 62, 64, 66, 68, 70, 72, '-'],
    hem: ['-', 48, 50, 52, 54, 56, 58, '-'],
    chest: ['-', 56, 58, 60, 62, 64, 66, '-'],
    sleeveLength: ['-', 78, 80.5, 83, 85.5, 88, 90.5, '-'],
  },
};

export const womensFootballJerseySizes: TableSizes = {
  sizeChartType: 'WomensFootballJerseySizes',
  sizes: {
    lengthFromHNP: ['-', 51, 53, 55, 57, 59, 61, '-'],
    chest: ['-', 56, 58, 60, 62, 64, 66, '-'],
    hem: ['-', 44, 46, 48, 50, 52, 54, '-'],
    sleeveLength: ['-', 41, 41.4, 42, 42.5, 43, 43.5, '-'],
  },
};

export const longSleeveWaffleSizes: TableSizes = {
  sizeChartType: 'LongSleeveWaffleSizes',
  sizes: {
    lengthFromHNP: ['-', 64, 66, 68, 70, 72, 74, '-'],
    chest: ['-', 58, 60, 62, 64, 66, 68, '-'],
    hem: ['-', 57, 59, 61, 63, 65, 67, '-'],
    sleeveLength: ['-', 53.5, 55, 56.6, 58, 59.5, 61, '-'],
  },
};
export const fauxFurZipUpHoodieSizes: TableSizes = {
  sizeChartType: 'FauxFurZipUpHoodieSizes',
  sizes: {
    lengthFromHSP: ['-', 65, 67, 69, 71, 73, 75, '-'],
    underarmChest: ['-', 47, 49, 51, 53, 55, 57, '-'],
    hem: ['-', 28.5, 30.5, 32.5, 34.5, 36.5, 38.5, '-'],
    sleeveLength: ['-', 73.5, 75, 76.6, 78, 79.5, 81, '-'],
  },
};
export const boxersSizes: TableSizes = {
  sizeChartType: 'BoxersSizes',
  sizes: {
    waist: ['-', 31.5, 33.5, 35.5, 37.5, 39.5, 41.5, '-'],
    hem: ['-', 21.5, 22.5, 23.5, 24.5, 25.5, 26.5, '-'],
    lengthIncWaist: ['-', 32, 33, 34, 35, 36, 37, '-'],
  },
};

export const topLeagueTrackJacketSizes: TableSizes = {
  sizeChartType: 'TopLeagueTrackJacketSizes',
  sizes: {
    lengthFromHSP: ['-', 65, 67, 69, 71, 73, 75, '-'],
    underarmChest: ['-', 59, 61, 63, 65, 67, 69, '-'],
    hem: ['-', 42, 44, 46, 48, 50, 52, '-'],
    sleeveLength: ['-', 79.5, 81, 82.5, 84, 85.5, 87, '-'],
  },
};

export const topLeagueTrackPantsSizes: TableSizes = {
  sizeChartType: 'TopLeagueTrackPantsSizes',
  sizes: {
    lengthIncWaist: ['-', 103, 105, 107, 109, 111, 113, '-'],
    waist: ['-', 32, 34, 36, 38, 40, 42, '-'],
    hem: ['-', 26.4, 27.4, 28.2, 29, 29.8, 30.6, '-'],
  },
};

export const racerKnitSizes: TableSizes = {
  sizeChartType: 'RacerKnitSizes',
  sizes: {
    lengthFromHSP: ['-', 60.5, 62.5, 64.5, 66.5, 68.5, 70.5, '-'],
    underarmChest: ['-', 60, 62, 64, 66, 68, 70, '-'],
    hem: ['-', 42, 44, 46, 48, 50, 52, '-'],
  },
};

export const shortSizes: TableSizes = {
  sizeChartType: 'shortSizes',
  sizes: {
    waist: ['-', 32, 34, 36, 38, 40, 42, 44],
    hem: ['-', 34, 35, 36, 37, 38, 39, 40],
    lengthWidthWaistband: ['-', 56, 57, 58, 59, 60, 61, 62],
  },
};

export const jerseySizes: TableSizes = {
  sizeChartType: 'JerseySizes',
  sizes: {
    lengthHSP: ['-', 66, 68, 70, 72, 74, 76, '-'],
    underarmChest: ['-', 58, 60, 62, 64, 66, 68, '-'],
    hem: ['-', 59, 61, 63, 65, 67, 69, '-'],
  },
};

export const meshShortsSizes: TableSizes = {
  sizeChartType: 'MeshShortsSizes',
  sizes: {
    lengthHSP: ['-', 33.5, 35.5, 37.5, 39.5, 41.5, 43.5, 45.5],
    hem: ['-', 33.5, 34.5, 35.5, 36.5, 37.5, 38.5, 39.5],
    lengthIncWaist: ['-', 53, 54, 55, 56, 57, 58, 59],
  },
};

export const cottonTrackTopSizes: TableSizes = {
  sizeChartType: 'CottonTrackTopSizes',
  sizes: {
    lengthHSP: ['-', 65, 67, 69, 71, 73, 75, '-'],
    chest: ['-', 57, 59, 61, 63, 65, 67, '-'],
    hem: ['-', 42, 44, 46, 48, 50, 52, '-'],
  },
};
export const pixelStarBeanieSizes: TableSizes = {
  sizeChartType: 'PixelStarBeanieSizes',
  sizes: {
    width: [26],
    height: [20],
  },
};

export const waffleBeanieSizes: TableSizes = {
  sizeChartType: 'WaffleBeanieSizes',
  sizes: {
    width: [27],
    height: [19.5],
  },
};

export const starGirlTeeSizes: TableSizes = {
  sizeChartType: 'StarGirlTeeSizes',
  sizes: {
    lengthHSP: ['-', 45, 47, 49, 51, 53, 55],
    chest: ['-', 36, 38, 40, 42, 44, 46],
    hem: ['-', 36, 38, 40, 42, 44, 46],
  },
};

export const twoInTwoCargoPantsShortsSizes: TableSizes = {
  sizeChartType: 'TwoInTwoCargoPantsShortsSizes',
  sizes: {
    waist: ['-', 78, 82, 86, 90, 94, 98, '-'],
    hem: ['-', 29.5, 30, 30.5, 31, 31.5, 32, '-'],
    insideLeg: ['-', 75, 75, 75, 78, 78, 78, '-'],
  },
};
export const furZipUpHoodieSizes: TableSizes = {
  sizeChartType: 'FurZipUpHoodieSizes',
  sizes: {
    lengthFromHSP: ['-', 53, 54.5, 56, 57.5, 59, 60.5, '-'],
    underarmChest: ['-', 47, 49, 51, 53, 55, 57, '-'],
    hem: ['-', 28.5, 30.5, 32.5, 34.5, 36.5, 38.5, '-'],
    sleeveLength: ['-', 73.5, 75, 76.6, 78, 79.5, 81, '-'],
  },
};

export const planetSweaterSizes: TableSizes = {
  sizeChartType: 'PlanetSweaterSizes',
  sizes: {
    frontLength: ['-', 62, 62, 64, 66, 68, 70, '-'],
    chest: ['-', 59, 61, 63, 65, 67, 69, '-'],
    hem: ['-', 52, 54, 56, 58, 60, 62, '-'],
    sleeveLength: ['-', 65, 67, 68, 69, 70, 71, '-'],
  },
};

export const zipUpSweaterSizes: TableSizes = {
  sizeChartType: 'ZipUpSweaterSizes',
  sizes: {
    lengthFromHSP: ['-', 62.5, 64.5, 66.5, 68.5, 70.5, '-', '-'],
    underarmChest: ['-', 61, 63, 65, 67, 69, '-', '-'],
    hem: ['-', 45, 47, 49, 51, 53, '-', '-'],
    sleeveLength: ['-', 78, 79, 80, 81, 82, '-', '-'],
  },
};

export const flannelShirtSizes: TableSizes = {
  sizeChartType: 'FlannelShirtSizes',
  sizes: {
    lengthFromHSP: ['-', 66, 68, 70, 72, 74, 76, '-'],
    underarmChest: ['-', 70, 72, 74, 76, 78, 80, '-'],
    hem: ['-', 65, 67, 69, 71, 73, 75, '-'],
    sleeveLength: ['-', 52.5, 53.5, 54.5, 55.5, 56.5, 57.5, '-'],
  },
};

export const trapperHatSizes: TableSizes = {
  sizeChartType: 'TrapperHatSizes',
  sizes: {
    width: [23],
    height: [20],
  },
};

export const columns = [
  'SIZES',
  'XXS',
  'XS',
  'S',
  'M',
  'L',
  'XL',
  'XXL',
  'XXXL',
];
export const columnsWithNumbers = [
  'SIZES',
  'XXS (26/28)',
  'XS (28/30)',
  'S (30/32)',
  'M (32/32)',
  'L (34/32)',
  'XL (36/32)',
  'XXL (38/32)',
  'XXXL (40/32)',
];

export const oneSizeColumns = ['SIZES', 'ONE SIZE'];

export const getTables = (isMobile: boolean) => [
  // Ordered by first appearance in SHOP_PRODUCT_ORDER; unlisted types last
  // 0. Puffer
  {
    title: 'Puffer',
    sizing: buildRows(pufferSizes),
    img: pufferSizing,
  },
  // 1. tech jacket
  {
    title: 'tech jacket',
    sizing: buildRows(techJacketSizes),
    img: techJacketSizing,
  },
  // 2. polar fleece
  {
    title: 'polar fleece',
    sizing: buildRows(polarFleeceSizes),
    img: polarFleeceSizing,
  },
  // 3. Zip up
  {
    title: 'Zip up',
    sizing: buildRows(zipUpSizes),
    img: zipUpSizing,
  },
  // 4. Cuffed Sweatpants
  {
    title: 'Cuffed Sweatpants',
    sizing: buildRows(cuffedSweatpantsSizes),
    img: cuffedSweatpants,
  },
  // 5. Long sleeve
  {
    title: 'Long sleeve',
    sizing: buildRows(longSleeveSizes),
    img: longSleeveImage,
  },
  // 6. Straight Leg Sweatpants
  {
    title: 'Straight Leg Sweatpants',
    sizing: buildRows(straightLegSweatpantsSizes),
    img: straightLegSweatpants,
  },
  // 7. knitted sweater
  {
    title: 'knitted sweater',
    sizing: buildRows(knitJacketSizes),
    img: knitwearSizing,
  },
  // 8. Knitted varsity zip-up
  {
    title: 'Knitted varsity zip-up',
    sizing: buildRows(varsityJacketSizes),
    img: varsityJacketSizing,
  },
  // 9. Stargirl Zip up
  {
    title: 'Stargirl Zip up',
    sizing: buildRows(stargirlZipUpHoodieSizes),
    img: stargirlZipUpHoodieSizing,
  },
  // 10. hoodies
  {
    title: 'hoodies',
    sizing: buildRows(hoodieSizes),
    img: hoodieSizing,
  },
  // 11. crewneck
  {
    title: 'crewneck',
    sizing: buildRows(crewneckSizes),
    img: crewneckSizingImage,
  },
  // 12. Flannel Shirt
  {
    title: 'Flannel Shirt',
    sizing: buildRows(flannelShirtSizes),
    img: flannelShirtSizing,
  },
  // 13. Denim Jeans
  {
    title: 'Denim Jeans',
    sizing: buildRows(denimJeansSizes),
    img: jeansSizing,
  },
  // 14. Cargo Pants
  {
    title: 'Cargo Pants',
    sizing: buildRows(cargoSizes),
    img: camoCargosImg,
    imageStyle: { width: isMobile ? '50%' : '20%' },
  },
  // 15. football Jersey
  {
    title: 'football Jersey',
    sizing: buildRows(footballJerseySizes),
    img: footballJersey,
  },
  // 16. T-Shirt
  {
    title: 'T-Shirt',
    sizing: buildRows(tshirtSizes),
    img: tshirtSizing,
  },
  // 17. Stargirl tee
  {
    title: 'Stargirl tee',
    sizing: buildRows(starGirlTeeSizes),
    img: starGirlTeeImage,
  },
  // 18. Mens Tank Top
  {
    title: 'Mens Tank Top',
    sizing: buildRows(mensTankTopSizes),
    img: mensTankTopSizingImage,
  },
  // 19. Womens Tank Top
  {
    title: 'Womens Tank Top',
    sizing: buildRows(womensTankTopSizes),
    img: womensTankTopSizesImage,
  },
  // 20. boxers
  {
    title: 'boxers',
    sizing: buildRows(boxersSizes),
    img: boxers,
  },
  // 21. shorts
  {
    title: 'shorts',
    sizing: buildRows(shortSizes),
    img: ShortsImage,
  },
  // 22. Reversible Bomber
  {
    title: 'Reversible Bomber',
    sizing: buildRows(reversibleBomberSizes),
    img: reversibleBomberSizing,
  },
  // 23. button up shirt
  {
    title: 'button up shirt',
    sizing: buildRows(buttonUpShirtSizes),
    img: buttonUpShirt,
  },
  // 24. Stargirl Corset Zip up
  {
    title: 'Stargirl Corset Zip up',
    sizing: buildRows(stargirlCorsetZipUpHoodieSizes),
    img: stargirlCorsetZipUpHoodieSizing,
  },
  // // 20. jersey
  // {
  //   title: 'jersey',
  //   sizing: buildRows(jerseySizes),
  //   img: jerseyImage,
  // },
  // // 24. fur zip up
  // {
  //   title: 'fur zip up',
  //   sizing: buildRows(furZipUpHoodieSizes),
  //   img: FurZipUpHoodieImage,
  // },
  // // 26. wide-leg sweatpants
  // {
  //   title: 'wide-leg sweatpants',
  //   sizing: buildRows(wideSweatpantsSizes),
  //   img: wideSweatpantsSizing,
  //   styles: { width: isMobile ? '50%' : '20%' },
  // },
  // // 27. racer knit
  // {
  //   title: 'racer knit',
  //   sizing: buildRows(racerKnitSizes),
  //   img: racerKnit,
  // },
  // // 28. straight-leg sweatpants (duplicate - sweatpantsSizes)
  // {
  //   title: 'straight-leg sweatpants',
  //   sizing: buildRows(sweatpantsSizes),
  //   img: sweatpantsSizing,
  // },
  // // 29. button up shirt
  // {
  //   title: 'button up shirt',
  //   sizing: buildRows(buttonUpShirtSizes),
  //   img: buttonUpShirt,
  // },
  // // 30. bikini
  // {
  //   title: 'bikini',
  //   sizing: buildRows(bikiniSizes),
  //   img: bikini,
  // },
  // // 31. denim shorts
  // {
  //   title: 'denim shorts',
  //   sizing: buildRows(denimShortsSizes),
  //   img: denimShortsImage,
  // },
  // // 32. mesh shorts
  // {
  //   title: 'mesh shorts',
  //   sizing: buildRows(meshShortsSizes),
  //   img: meshShortsImage,
  // },
  // // 33. top league track jacket
  // {
  //   title: 'top league track jacket',
  //   sizing: buildRows(topLeagueTrackJacketSizes),
  //   img: topLeagueTrackJacket,
  // },
  // // 34. top league track pants
  // {
  //   title: 'top league track pants',
  //   sizing: buildRows(topLeagueTrackPantsSizes),
  //   img: topLeagueTrackPants,
  // },
  // // 35. cotton track zip-up
  // {
  //   title: 'cotton track zip-up',
  //   sizing: buildRows(cottonTrackTopSizes),
  //   img: cottonTrackTopImage,
  // },
  // // 36. Long sleeve star camo jersey
  // {
  //   title: 'Long sleeve star camo jersey',
  //   sizing: buildRows(longSleeveSizes),
  //   img: longSleeveImage,
  // },
  // // 37. American football jersey
  // {
  //   title: 'American football jersey',
  //   sizing: buildRows(americanFootballJerseySizes),
  //   img: americanFootballJerseyImage,
  // },
  // // 38. 2 in 2 cargo pants shorts
  // {
  //   title: '2 in 2 cargo pants shorts',
  //   sizing: buildRows(twoInTwoCargoPantsShortsSizes),
  //   img: twoInTwoCargoPantsShortsImage,
  // },
  // // 39. stargirl tee (baby tee)
  // {
  //   title: 'baby tee',
  //   sizing: buildRows(babyTeeSizes),
  //   img: babyTeeImage,
  // },
  // // 40. men's ribbed tank top
  // {
  //   title: "men's ribbed tank top",
  //   sizing: buildRows(lightweightTankSizes),
  //   img: LightWeightTankImage,
  // },
  // // 41. sweat shorts
  // {
  //   title: 'sweat shorts',
  //   sizing: buildRows(sweatShortsSizing),
  //   img: sweatSorts,
  // },
  // // 42. workwear jacket
  // {
  //   title: 'workwear jacket',
  //   sizing: buildRows(workwearJacketSizes),
  //   img: workwearJacket,
  // },
  // // 43. wide leg jeans
  // {
  //   title: 'wide leg jeans',
  //   sizing: buildRows(wideLegDenimSizes),
  //   img: wideLegDenim,
  // },
  // // 44. velour track jacket
  // {
  //   title: 'velour track jacket',
  //   sizing: buildRows(velourTrackJacketSizes),
  //   img: velourJacket,
  // },
  // // 45. velour track pants
  // {
  //   title: 'velour track pants',
  //   sizing: buildRows(velourTrackPantsSizes),
  //   img: velourPants,
  // },
  // // 46. Star Camo Beanie
  // {
  //   title: 'star camo beanie',
  //   sizing: buildRows(starCamoBeanieSizes),
  //   img: starCamoBeanie,
  // },
  // // 47. new polar fleece
  // {
  //   title: 'Fleece',
  //   sizing: buildRows(newPolarFleeceSizes),
  //   img: newPolarFleece,
  // },
  // // 48. denim workwear jacket
  // {
  //   title: 'denim workwear jacket',
  //   sizing: buildRows(workwearSizes),
  //   img: workwearSizing,
  // },
  // // 49. pixer star beanie
  // {
  //   title: 'pixer star beanie',
  //   sizing: buildRows(pixelStarBeanieSizes),
  //   img: pixelStarBeanie,
  // },
  // // 50. Foldover beanie
  // {
  //   title: 'foldover beanie',
  //   sizing: buildRows(foldoverBeanieSizes),
  //   img: foldoverBeanie,
  // },
  // // 51. faux fur zip up hoodie
  // {
  //   title: 'faux fur zip up hoodie',
  //   sizing: buildRows(fauxFurZipUpHoodieSizes),
  //   img: fauxFurZipUpHoodieImg,
  // },
  // // 52. track top
  // {
  //   title: 'reflective track top',
  //   sizing: buildRows(trackTopSizes),
  //   img: trackTop,
  // },
  // // 53. track pants
  // {
  //   title: 'reflective track pants',
  //   sizing: buildRows(trackPantsSizes),
  //   img: trackPants,
  // },
  // // 54. new hoodie shape (not available - skipped)
  // // 55. mesh layered t-shirt
  // {
  //   title: 'mesh layered t-shirt',
  //   sizing: buildRows(meshLayeredTShirtSizes),
  //   img: layeredTShirt,
  // },
  // // 56. velour sweatpants
  // {
  //   title: 'velour sweatpants',
  //   sizing: buildRows(velourSweatpantsSizes),
  //   img: velourTrackPants,
  // },
  // // 57. cropped zip-ups
  // {
  //   title: 'cropped zip-ups',
  //   sizing: buildRows(croppedZipupSizes),
  //   img: croppedZipupSizing,
  // },
  // // 58. long sleeve waffle
  // {
  //   title: 'long sleeve waffle',
  //   sizing: buildRows(longSleeveWaffleSizes),
  //   img: waffleLongSleeve,
  // },
  // // 59. racer jacket
  // {
  //   title: 'racer jacket',
  //   sizing: buildRows(racerJacketSizes),
  //   img: racerJacket,
  // },
  // // 60. womens one shoulder top
  // {
  //   title: 'womens one shoulder top',
  //   sizing: buildRows(womensOneShoulderTopSizes),
  //   img: oneShoulderTop,
  // },
  // // 61. womens football jersey
  // {
  //   title: 'womens football jersey',
  //   sizing: buildRows(womensFootballJerseySizes),
  //   img: womensFootballJersey,
  // },
  // // 62. women's halter top
  // {
  //   title: "women's halter top",
  //   sizing: buildRows(halterTopSizes),
  //   img: halterTop,
  // },
  // // 63. football mesh shorts
  // {
  //   title: 'football mesh shorts',
  //   sizing: buildRows(footballMeshShortsSizes),
  //   img: footballMeshShorts,
  // },
  // // 64. denim skirt
  // {
  //   title: 'denim skirt',
  //   sizing: buildRows(denimSkirtSizing),
  //   img: pleatedSkirtSizing,
  // },
  // // 65. cropped boxy t-shirt
  // {
  //   title: 'cropped boxy t-shirt',
  //   sizing: buildRows(croppedBoxyTshirtSizes),
  //   img: croppedBoxyTshirt,
  // },
  // // 66. swimming shorts
  // {
  //   title: 'swimming shorts',
  //   sizing: buildRows(swimmingShortsSizes),
  //   img: swimmingShorts,
  // },
  // // 67. lounge corset
  // {
  //   title: 'lounge corset',
  //   sizing: buildRows(loungeCorsetSizes),
  //   img: loungeCorset,
  // },
  // // 68. womens shorts
  // {
  //   title: 'womens shorts',
  //   sizing: buildRows(womensShortsSizes),
  //   img: womensShorts,
  // },
  // // 69. ribbed men's tank-tops
  // {
  //   title: "ribbed men's tank-tops",
  //   sizing: buildRows(ribbedMensTankTopSizes),
  //   img: ribbedMensTankTopSizingImage,
  // },
  // // 70. performance t-shirt
  // {
  //   title: 'performance t-shirt',
  //   sizing: buildRows(performanceTShirtSizes),
  //   img: performanceTShirt,
  // },
  // // 71. sweat skirt
  // {
  //   title: 'sweat skirt',
  //   sizing: buildRows(sweatSkirtSizes),
  //   img: sweatSkirt,
  // },
  // // 72. denim jacket
  // {
  //   title: 'denim jacket',
  //   sizing: buildRows(jacketSizes),
  //   img: jacketSizing,
  // },
  // // 73. pleated skirt
  // {
  //   title: 'pleated skirt',
  //   sizing: buildRows(slinkySkirtSizes),
  //   img: slinkySkirt,
  // },
  // // 74. mens washed ribbed zip-up
  // {
  //   title: 'mens washed ribbed zip-up',
  //   sizing: buildRows(mensWashedRibbedZipUpSizes),
  //   img: mensZipKnit,
  // },
  // // 75. womens washed ribbed zip-up
  // {
  //   title: 'womens washed ribbed zip-up',
  //   sizing: buildRows(womensWashedRibbedZipUpSizes),
  //   img: womensZipKnit,
  // },
  // // 76. ribbed women's tank-tops
  // {
  //   title: "ribbed women's tank-tops",
  //   sizing: buildRows(ribbedWomensTankTopSizes),
  //   img: womensTankTopSizing,
  // },
  // // 77. ripstop camo skirt
  // {
  //   title: 'ripstop camo skirt',
  //   sizing: buildRows(ripstopSkirtSizes),
  //   img: ripstopSkirt,
  // },
  // // 78. denim corset top
  // {
  //   title: 'denim corset top',
  //   sizing: buildRows(denimCorsetSizing),
  //   img: denimCorsetTopSizing,
  // },
  // // 79. camo thermal long-sleeve
  // {
  //   title: 'camo thermal long-sleeve',
  //   sizing: buildRows(thermalLongSleeveSizes),
  //   img: raglanLongSleeveTShirt,
  // },
  // // 80. waterproof tech-pants
  // {
  //   title: 'waterproof tech-pants',
  //   sizing: buildRows(techPantsSizes),
  //   img: techPantsSizing,
  // },

  // Additional items not in productSizings
  // {
  //   title: 'Planet Sweater',
  //   sizing: buildRows(planetSweaterSizes),
  //   img: planetSweaterSizing,
  // },
  // {
  //   title: 'Zip up Sweater',
  //   sizing: buildRows(zipUpSweaterSizes),
  //   img: zipUpSweaterSizing,
  // },
  // {
  //   title: 'basics zip-up',
  //   sizing: buildRows(basicsZipUpHoodieSizes),
  //   img: basicsZipUpHoodieSizing,
  // },
  // {
  //   title: 'waffle beanie',
  //   sizing: buildRows(waffleBeanieSizes),
  //   img: beanieSizing,
  // },
  // {
  //   title: 'lightweight tank',
  //   sizing: buildRows(lightweightTankSizes),
  //   img: lightweightTank,
  // },
  // {
  //   title: 'long sleeve t-shirts',
  //   sizing: buildRows(longSleeveTshirtSizes),
  //   img: longSleeveTshirtSizing,
  // },
];
